import React from "react";

import { isEnabled } from "utils/featureFlags";

import { Icon, Button } from "aible";

import giftIcon from "images/party-horn-light.svg";

import styles from "./style.module.css";

const WARNING_KEY = "chat_aible_beta_warning_2023_10";

export default class ChatAibleBetaWarning extends React.Component {
  constructor(props) {
    super(props);
    // props.removeItem(WARNING_KEY)

    const savedHidden = props.getItem(WARNING_KEY);

    this.state = {
      isHidden: Boolean(savedHidden),
      neverShow: false
    };
  }

  handleClose() {
    const { storeItem } = this.props;
    if (this.state.neverShow) {
      storeItem(WARNING_KEY, true);
    }
    return this.setState({ isHidden: true });
  }

  renderFooter() {
    return (
      <div className={styles.warningFooter + " " + styles.isDataReadinessWarning}>
        <input
          type="checkbox"
          style={{ marginBottom: "3px" }}
          checked={this.state.neverShow}
          onChange={() => {
            this.setState({ neverShow: !this.state.neverShow });
          }}
        />
        <div className={styles.warningFooterContent + " " + styles.isDataReadinessWarning}>
          {"Don't show this again."}
        </div>
        <Button onClick={() => this.handleClose()} className={styles.warningFooterButton}>
          {"Okay"}
        </Button>
      </div>
    );
  }

  render() {
    if (this.state.isHidden || !isEnabled("chat-aible-beta-warning")) {
      return <React.Fragment />;
    }

    return (
      <div className={styles.warningWrapper + " " + styles.isChatAibleBetaWarning}>
        <div className={styles.warning}>
          <div className={styles.warningHeader + " " + styles.isDataReadinessWarning}>
            <Icon src={giftIcon} />
            <div className={styles.warningTitle + " " + styles.isChatAibleBetaWarning}>
              <strong>{"Welcome to the 2023 Aible Hackathon! "}</strong>
              <span>
                {
                  "For your security, please refrain from uploading proprietary or confidential information to your Aible Hackathon account."
                }
              </span>
            </div>
          </div>
          {this.renderFooter()}
        </div>
      </div>
    );
  }
}
